import { POPUP_SURFACE } from '@crowdex/ui/lib/surfaces';
import { Columns2 } from 'lucide-react';
import { useDesktopShellStore } from '@/lib/desktop-shell/store-context';

/**
 * Floating overlays rendered above the conversation workspace: the split-dock
 * preview shown while dragging a pane, and the ghost label of a thread being
 * dragged. Both read their state straight from the desktop shell store.
 */
export function ConversationDockOverlays() {
  const dockPreview = useDesktopShellStore((state) => state.dockPreview);
  const draggedThread = useDesktopShellStore((state) => state.draggedThread);

  return (
    <>
      {dockPreview !== null && (
        // The explicit drop zone of D55: a dashed blue edge where the conversation will open.
        <div
          className="pointer-events-none fixed z-drag flex flex-col items-center justify-center gap-2 rounded-2xl border-2 border-running border-dashed bg-running/5"
          style={{
            height: dockPreview.height,
            left: dockPreview.left,
            top: dockPreview.top,
            width: dockPreview.width,
          }}
        >
          <Columns2 className="size-6 text-running" />
          <p className="font-semibold text-running text-sm">Drop to open side by side</p>
        </div>
      )}
      {draggedThread !== null && (
        <div
          className={`${POPUP_SURFACE} pointer-events-none fixed z-drag max-w-64 truncate rounded-lg px-3 py-2 text-sm`}
          style={{ left: draggedThread.x + 14, top: draggedThread.y + 14 }}
        >
          {draggedThread.title}
        </div>
      )}
    </>
  );
}
